import React, { Dispatch, useEffect } from 'react'
import { notification } from "antd"
import Webcam from 'react-webcam';
import "./cameraRender.css"

const videoConstraints = {
  width: { min: 1280, ideal: 3840, max: 3840 },
  height: { min: 720, ideal: 2160, max: 2160 },
  frameRate: { max: 20, min: 20 },
  aspectRatio: 1
};

const CameraRender = (props: {
  webcamRef: React.LegacyRef<Webcam> | undefined, isOk: boolean,
  setRenderCamera: Dispatch<boolean>, closeOLPN: boolean, device: any, devices: any,
  resolution: { width: number, height: number, resolution: string } | undefined
}) => {
  const { resolution } = props

  useEffect(() => {
  }, [props.device, props.devices])

  return (
    <div style={{ position: "relative", height: "95%", zIndex: 2 }}>
      {props.device &&
        <Webcam
          mirrored={false}
          id={"webcam"}
          height={"100%"}
          width={"100%"}
          ref={props.webcamRef}
          videoConstraints={{
            width: { min: resolution?.width ?? 1920, max: resolution?.width ?? 3840 },
            height: { min: resolution?.height ?? 1080, max: resolution?.height ?? 2160 },
            frameRate: { max: 20, min: 20 },
            aspectRatio: 1,
            deviceId: props.device.deviceId
          }}
          onUserMedia={(e) => { }}
          onUserMediaError={(e) => {
            if (e.toString() === "OverconstrainedError") {
              notification.error({ message: "La résolution choisie n'est pas supportée par la caméra. Veuillez essayer une résolution plus basse." })
            }
          }}
        />
      }
      {!props.closeOLPN &&
        <div className={'canvas ' + (!props.isOk ? "canvas-border-ok" : 'canvas-border-nok')} id='canvas' />
      }
    </div>
  );
}

export default CameraRender